import { locKeys } from "components/flexComponents/WizardPackagePWA/l10n";
import * as React from "react";
import { PackagePartialStayProps } from "components/flexComponents/WizardPackagePWA/typings";
import { observer } from "mobx-react";
import { UitkCheckbox } from "uitk-react-switch";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";

export const PackagePartialStay = observer((props: PackagePartialStayProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan="all">
      <div>
        <UitkCheckbox
          id="package-partial-stay"
          onChange={props.togglePartialStay}
          checked={props.packageWizardState.partialStay}
        >
          {formatText(locKeys.partialStayAccommodationLabel)}
        </UitkCheckbox>
        <input
          type="hidden"
          name="isPartialStay"
          value={props.packageWizardState.partialStay ? 1 : 0}
          data-testid="partial-stay-input"
        />
      </div>
    </UitkLayoutGridItem>
  );
});
